/**
 * MTO Cart Guard
 *
 * After any cart update, detects add-on line items whose parent configured
 * item has been removed (orphans) and removes them automatically.
 *
 * Add-on items are identified by having an 'Applied to' line item property.
 * Both the main item and its add-on share a hidden '_config_id' property.
 */

async function removeOrphanedAddons() {
  let cart;
  try {
    cart = await fetch('/cart.js').then((r) => r.json());
  } catch {
    return;
  }

  const items = /** @type {Array<{key: string, properties: Record<string, string>}>} */ (cart.items);

  // Collect config IDs that belong to main (non-addon) items
  const mainConfigIds = new Set(
    items
      .filter((item) => item.properties['_config_id'] && !item.properties['Applied to'])
      .map((item) => item.properties['_config_id'])
  );

  // Find add-ons whose parent main item is no longer in the cart
  const orphans = items.filter(
    (item) => item.properties['Applied to'] && !mainConfigIds.has(item.properties['_config_id'])
  );

  if (orphans.length === 0) return;

  for (const orphan of orphans) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: orphan.key, quantity: 0 }),
      });
    } catch {
      // Non-fatal — the orphan will be caught on the next cart update
    }
  }

  // Reload to show the updated cart with orphans removed
  window.location.reload();
}

// Run on every cart update (fired by CartItemsComponent after any change)
document.addEventListener('cart:update', removeOrphanedAddons);

// Also run on initial page load to catch any pre-existing orphans
// (e.g. if the customer navigated away mid-session)
removeOrphanedAddons();
